import React, { useState, useEffect } from "react";

const Input = ({
  label,
  type,
  value,
  onChange,
  style,
  labelstyle,
  required,
  validate,
  warning,
  maxLen,
  className,
  ...rest
}) => {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    if (value !== undefined && value.length > 0) setIsActive(true);
  }, [value]);

  const handleTextChange = (e) => {
    if (e.target.value !== "") {
      setIsActive(true);
    } else {
      setIsActive(false);
    }
    onChange(e);
  };

  return (
    <div className={`float-label ${className}`} style={style}>
      <input
        {...rest}
        className={warning?.class}
        maxLength={maxLen}
        type={type}
        value={value}
        autoComplete="nope"
        onChange={(e) => {
          handleTextChange(e);
        }}
      />

      {label ? (
        <label
          style={labelstyle}
          className={isActive ? "Active" : ""}
          htmlFor="email"
        >
          {label} {required ? <span className="required-span">*</span> : null}
        </label>
      ) : null}
      <p className="float-right mb-0 validation-msg">
        <span className={warning?.class}>{warning?.msg}</span>
      </p>
    </div>
  );
};

const Textarea = ({
  label,
  value,
  onChange,
  style,
  required,
  validate,
  warning,
  ...rest
}) => {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    if (value !== undefined && value.length > 0) setIsActive(true);
  }, [value]);

  const handleTextChange = (e) => {
    if (e.target.value !== "") {
      setIsActive(true);
    } else {
      setIsActive(false);
    }
    onChange(e);
  };

  return (
    <div className="float-label" style={style}>
      <textarea
        {...rest}
        style={{
          backgroundColor: "#101010",
          // borderRadius: "10px",
          border: "none",
          borderBottom: "1px solid white",
          color: "white",
          height: "4rem",
        }}
        className={`no_outline ${warning?.class}`}
        value={value}
        onChange={(e) => {
          handleTextChange(e);
        }}
      />

      <label className={isActive ? "Active" : ""} htmlFor="email">
        {label} {required ? <span className="required-span">*</span> : null}
      </label>
      <p className="float-right mb-0 validation-msg">
        <span className={warning?.class}>{warning?.msg}</span>
      </p>
    </div>
  );
};

const PasswordInput = ({
  label,
  type,
  value,
  onChange,
  required,
  style,
  validate,
  warning,
  minLen,
  maxLen,
  ...rest
}) => {
  const [isActive, setIsActive] = useState(false);
  const [isFocus, setIsFocus] = useState(false);
  //  const [value, setValue] = useState('');
  const [showPass, setShowPass] = useState(false);

  useEffect(() => {
    if (value !== undefined && value.length > 0) setIsActive(true);
  }, [value]);

  // const [warningMsg, setWarningMsg] = useState('');
  // const [warningClass, setWarningClass] = useState('');

  const handleTextChange = (e) => {
    //setValue(e.target.value);
    if (e.target.value !== "") {
      setIsActive(true);
    } else {
      setIsActive(false);
    }

    // if(validate!==true) return;

    onChange(e);
    // if(e.target.value.length == 0){
    //     setWarningClass("");
    //     setWarningMsg("");
    // }else if(e.target.value.length <3){
    //     setWarningClass("red");
    //     setWarningMsg("Weak");

    // }else if(e.target.value.length <6){
    //     setWarningClass("yellow");
    //     setWarningMsg("Medium");
    // }else if(e.target.value.length <10){
    //     setWarningClass("blue");
    //     setWarningMsg("Strong");
    // }else {
    //     setWarningClass("green");
    //     setWarningMsg("Very Strong");
    // }
  };

  const handleFocus = (e) => {
    setIsFocus(true);
  };
  const handleBlur = (e) => {
    setIsFocus(false);
  };

  const showHidePassword = (e) => {
    if (showPass) setShowPass(false);
    else setShowPass(true);
  };

  return (
    <div className="float-label" style={style}>
      <p className={isFocus || isActive ? "password-active mb-0" : "mb-0"}>
        <input
          {...rest}
          className={warning?.class}
          type={showPass ? "text" : "password"}
          minLength={minLen}
          maxLength={maxLen}
          value={value}
          onBlur={(e) => handleBlur(e)}
          onFocus={(e) => handleFocus(e)}
          onChange={(e) => {
            handleTextChange(e);
          }}
        />
      </p>
      <span
        className={showPass ? "password-wrapper show-pass" : "password-wrapper"}
        onClick={(e) => showHidePassword(e)}
      ></span>
      <label className={isActive ? "Active" : ""} htmlFor="email">
        {label} {required ? <span className="required-span">*</span> : null}
      </label>
      <p className="float-right mb-0 validation-msg">
        <span className={warning?.class}>{warning?.msg}</span>
      </p>
    </div>
  );
};

export default Input;
export { PasswordInput, Textarea };
